export const GET_LOCATIONS_QUERY = /* GraphQL */ `
    query GetLocations(
        $first: Int!
        $after: String
        $query: String
        $includeInactive: Boolean
        $includeLegacy: Boolean
    ) {
        locations(
            first: $first
            after: $after
            query: $query
            includeInactive: $includeInactive
            includeLegacy: $includeLegacy
        ) {
            edges {
                node {
                    id
                    name
                    isActive
                    shipsInventory
                    fulfillsOnlineOrders
                    address {
                        address1
                        address2
                        city
                        zip
                        province
                        provinceCode
                        country
                        countryCode
                        phone
                        formatted
                    }
                }
            }
            pageInfo {
                hasNextPage
                endCursor
            }
        }
    }
`;

export interface GetLocationsVariables {
    [key: string]: unknown;
    first: number;
    after?: string;
    query?: string;
    includeInactive?: boolean;
    includeLegacy?: boolean;
}

export interface ShopifyLocationAddress {
    address1: string | null;
    address2: string | null;
    city: string | null;
    zip: string | null;
    province: string | null;
    provinceCode: string | null;
    country: string | null;
    countryCode: string | null;
    phone: string | null;
    formatted: string[];
}

export interface ShopifyLocation {
    id: string;
    name: string;
    isActive: boolean;
    shipsInventory: boolean;
    fulfillsOnlineOrders: boolean;
    address: ShopifyLocationAddress;
}

export interface GetLocationsResponse {
    locations: {
        nodes: ShopifyLocation[];
        pageInfo?: {
            hasNextPage: boolean;
            endCursor?: string;
        };
    };
}
